import { Button, RadioCustom, Typography } from '@p2p/components';
import { useState } from 'react';

import { MainContainer } from '../../../MainContainer';
import { PaymentId } from '../../../PaymentId';
import { issues } from './ProblemsScreen.constants';
import styles from './ProblemsScreen.module.scss';
import { IssuesKeys, ProblemsScreenProps } from './ProblemsScreen.types';

export const ProblemsScreen = ({ id, comeback, handleNext }: ProblemsScreenProps) => {
  const [selectedId, setSelectedId] = useState<IssuesKeys | null>(null);

  const handleChange = (key: IssuesKeys) => {
    setSelectedId(key);
  };

  return (
    <MainContainer className={styles.container} marginTop="2xl" maxWidth="460px">
      <Typography variant="h1" color="heading">
        Возникла проблема?
      </Typography>

      <PaymentId id={id} />

      <div className={styles.wrapper}>
        {Object.entries(issues).map(([key, value], index) => (
          <RadioCustom
            key={key}
            id={index}
            value={key}
            text={value}
            checked={selectedId === key}
            onChange={() => handleChange(key as IssuesKeys)}
          />
        ))}
      </div>

      <div className={styles.wrapper}>
        <Button
          onClick={() => handleNext(selectedId as IssuesKeys)}
          disabled={selectedId === null}
          fullWidth
        >
          Далее
        </Button>
        <Button onClick={comeback} variant="outlined" fullWidth>
          Вернуться к платежу
        </Button>
      </div>
    </MainContainer>
  );
};
